import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { BaseComponent } from '../../_base/base.component';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-auto-complete-multi',
  templateUrl: './auto-complete-multi.component.html',
  styleUrls: ['./auto-complete-multi.component.scss']
})
export class AutoCompleteMultiComponent extends BaseComponent implements OnInit {
  @Input('checkBox')
  checkBox: boolean = false;
  @Input('pickList')
  pickList: boolean = false;
  @Input('color')
  color: string = '';
  @Input('fontSize')
  fontSize: string = '';
  @Input('filtercallback')
  filtercallback: Function;
  @Input('collapesID')
  protected collapesID: String = 'autocompleteCollapse';
  @Input('DataList')
  protected DataList: any[];
  @Input('perantList')
  protected perantList: any[];
  @Input('label')
  protected label: string = '- Select -';
  @Input('background')
  protected background: string = '';
  protected query: string;
  protected filteredList: any[];
  @Input('SelectedList')
  protected SelectedList: any[] = [];
  public selectedPairantId: number;
  @Output('SelectedNotifer')
  protected SelectedNotifer = new EventEmitter();
  @Input('parantCallBack')
  parantCallBack: Function;
  configurations: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    suppressScrollY: false
  };
  isSelect: boolean = false;
  searchTerm: FormControl = new FormControl();
  constructor() {
    super();
    this.filteredList = [];
    this.SelectedList = [];
  }

  ngOnInit() {
    this.selectedPairantId = -1;
  }

  select(item) {
    this.SelectedList.push(item);
    const i = this.filteredList.findIndex(e => e.id === item.id);
    this.query = '';
    this.filteredList.splice(i, 1);
    this.SelectedNotifer.emit(this.SelectedList);
  }

  remove(item) {
    this.SelectedList.splice(this.SelectedList.indexOf(item), 1);
    this.SelectedNotifer.emit(this.SelectedList);
  }

  filter() {
    if (this.filtercallback) {
      this.filtercallback(this.query).subscribe(value => {
        this.filteredList = [];
        value.forEach(element => {
          const i = this.SelectedList.findIndex(f => f.id === element.id);
          if (i === -1) {
            this.filteredList.push(element);
          }
        });
      });
      return;
    }
    if (!this.SelectedList) {
      this.SelectedList = [];
    }

    this.filteredList = this.DataList.map(x => Object.assign({}, x));
    if (this.SelectedList.length) {
      this.SelectedList.forEach(element => {
        const i = this.filteredList.findIndex(e => e.id === element.id);

        if (i > -1) {
          this.filteredList.splice(i, 1);
        }
      });
    } else {
      this.SelectedList = [];
    }

    const newlist = [];
    for (let i = 0; i < this.filteredList.length; i++) {
      const item = this.filteredList[i];

      if (item.name.toLowerCase().indexOf(this.query.toLocaleLowerCase()) !== -1 || !this.query) {
        newlist.push({ ...item });
      } else {
      }
    }
    this.filteredList = newlist;
  }

  selectCheckbox(event, item) {
    console.log(event);
    const i = this.SelectedList.findIndex(f => f.id === item.id);
    if (event.checked) {
      if (i === -1) {
        this.SelectedList.push(item);
      }
    } else {
      this.SelectedList.splice(i, 1);
    }
    this.SelectedNotifer.emit(this.SelectedList);
    if (this.SelectedList.length === this.DataList.length) {
      this.isSelect = true;
    } else {
      this.isSelect = false;
    }
  }

  selectAll(event) {
    if (event.checked) {
      this.SelectedList = [...this.DataList];
    } else {
      this.SelectedList = [];
    }
    this.SelectedNotifer.emit(this.SelectedList);
  }

  ischeckeds(item): boolean {
    if (this.isSelect) {
      return true;
    } else {
      return this.SelectedList.findIndex(f => f.id === item.id) !== -1;
    }
  }

  parantChanged(event) {
    this.filteredList = [];
    this.SelectedList = [];
    this.DataList = this.parantCallBack(event.value);
    this.filteredList = this.DataList;

    // console.log (  this.DataList);
  }

  public clear() {
    this.filteredList = [];
    this.SelectedList = [];
    this.selectedPairantId = -1;
  }

  isChecked(element) {
    const i = this.SelectedList.findIndex(f => f.id === element.id);
    return i !== -1;
  }

  onCheckChange(event, element) {
    if (event.checked) {
      const i = this.filteredList.findIndex(f => f.id === element.id);
      this.SelectedList.push(_.cloneDeep(element));
      this.filteredList.splice(i, 1);
      this.SelectedNotifer.emit(_.cloneDeep(this.SelectedList));
    } else {
    }
  }

  removefromselection(element) {
    const i = this.SelectedList.findIndex(f => f.id === element.id);
    if (i !== -1) {
      this.SelectedList.splice(i, 1);
      this.SelectedNotifer.emit(this.SelectedList);
      this.filteredList.push(_.cloneDeep(element));
      this.SelectedNotifer.emit(_.cloneDeep(this.SelectedList));
    }
  }
}
